export const getFilters = (filters: any): any[] => [
  {
    type: 'dataProvider',
    displayName: 'Data Provider',
    value: filters?.country || '',
    icon: 'mdi:source-branch'
  }
];
